import { useScopedI18n } from '@locales/client';
import { useLocaleFormat } from '@/shared/hooks/useLocaleFormat';
import { Link } from '@/shared/ui/link';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { BackButtonBox, NavigationBackButton, BackButtonIcon } from '@/flat-pages/bonuses/ui/styles';
import { BonusInfo } from '@/flat-pages/bonuses/ui/bonus-info';

interface ProfileBonusInfoSectionProps {
  dataWelcomeAvailable: any;
}

export const ProfileBonusInfoSection = ({
  dataWelcomeAvailable,
}: ProfileBonusInfoSectionProps) => {
  const formatUrl = useLocaleFormat();
  const tAuth = useScopedI18n('auth');

  return (
    <>
      <BackButtonBox>
        <Link href={formatUrl('bonuses')}>
          <NavigationBackButton>
            <BackButtonIcon />
            <BodyTextRegularB color="#AFAFAF">{tAuth('reset.back')}</BodyTextRegularB>
          </NavigationBackButton>
        </Link>
      </BackButtonBox>
      <BonusInfo dataWelcomeAvailable={dataWelcomeAvailable} />
    </>
  );
};
